import { D as o } from "./luxon-88c249ba-ecb6bfbf.js";
const l = (t, e = "en-GB", a = "dd/mm/yyyy") => t === null ? a : (e === "en" && (e = "en-GB"), o.fromJSDate(t).setLocale(e).toLocaleString(o.DATE_SHORT)), u = (t) => {
  let s = o.fromJSDate(t).startOf("month").startOf("week").plus({ days: 1 });
  s.weekday !== 1 && (s = s.minus({ days: s.weekday - 1 }));
  const c = 42, r = [];
  let n = s;
  for (let f = 0; f < c; f++)
    r.push(n), n = n.plus({ days: 1 });
  return r;
}, y = (t) => o.fromJSDate(t).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toJSDate(), d = (t) => o.fromJSDate(t).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toJSDate(), m = (t, e) => {
  if (t && e) {
    const a = t.startOf("day").setZone("utc"), s = e.startOf("day");
    return s && a < s;
  }
  return !1;
}, D = (t, e) => {
  if (t && e) {
    const a = t.startOf("day").setZone("utc"), s = e.startOf("day");
    return s && a > s;
  }
  return !1;
}, O = (t, e = "en-GB") => t ? o.fromJSDate(t).setLocale(e).toFormat("yyyy-MM-dd") : "";
export {
  y as a,
  D as b,
  l as c,
  O as f,
  u as g,
  m as i,
  d as s
};
